import styled from 'styled-components';
import OpenIn from '@results/components/ShopCard/OpenIn';

const StyledOpenIn = styled(OpenIn)`
  border-radius: ${({ theme }) => theme.spacing(12, 12, 0, 0)};
  padding: 5px;
`;

export default StyledOpenIn;
